import React from 'react';
import PropTypes from 'prop-types';
import Markdown from '../../../components/Markdown';
import { Wrap, Title, ListSection, Text } from './Place.style';

const Place = ({ place }) => place ? (
    <Wrap id="place-section">
      {<Title>{place.title}</Title>}
      <ListSection>
        {place.contents.map(({ area, description, entryId }) => (
          <li key={entryId}>
            <dt>{area}</dt>
            <dd>
              <Markdown src={description} Component={Text} />
            </dd>
          </li>
        ))}
      </ListSection>
    </Wrap>
  ) : null;
Place.defaultProps = {
  place: null,
};
Place.propTypes = {
  place: PropTypes.shape(),
};
export default Place;



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/Place/Place.js